import { User } from "@supabase/supabase-js";
import { supabase } from "libs/supabase";
import { useLoading } from "providers/loading";
import { useEffect, useState } from "react";

export const useUser = () => {
  const [user, setUser] = useState<User | null>(null);
  const { setLoading } = useLoading();

  useEffect(() => {
    const getUser = async () => {
      setLoading(true);
      await supabase.auth.getUser().then((res) => {
        setUser(res.data.user);
      });
      setLoading(false);
    };
    getUser();
    supabase.auth.onAuthStateChange((ev) => {
      if (ev === "SIGNED_IN" || ev === "SIGNED_OUT") {
        getUser();
      }
    });
  }, []);

  return user;
};
